import { FC } from 'react';

import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { BoximusPrime } from '@hsp/react-component-library';

import { s } from 'utilities/strings';

import { useNameInputConfiguration } from './hooks';

const NameInput: FC = () => {
  const { errors, props, readOnly, ref } = useNameInputConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Audience', 'Site.Name'])}</Label>
      <Col sm={8}>
        <BoximusPrime
          {...props}
          className={classNames({
            'is-invalid': get(errors, 'name.type') === 'too_small',
          })}
          placeholder={s(['Site.Enter', 'Site.Name'])}
          plaintext={readOnly}
          readOnly={readOnly}
          ref={ref}
          type="text"
        />
        <FormFeedback type="invalid">{get(errors, 'name.message')}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

export default NameInput;
